/** @jsxImportSource react */
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from '../i18n';
import Sidebar from './Sidebar';
import Header from './Header';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = React.useState(false);
  const [isDesktopSidebarCollapsed, setIsDesktopSidebarCollapsed] = React.useState(false);
  const location = useLocation();
  const { t, isRtl } = useTranslation();

  // Close mobile sidebar on navigation
  React.useEffect(() => {
    setIsMobileSidebarOpen(false);
  }, [location.pathname]);

  const getPageTitle = (pathname: string) => {
    const route = pathname.split('/')[1] || 'dashboard';
    const tKey = route.replace('-', '');
    return t(tKey) || t('dashboard');
  };
  
  const pageTitle = getPageTitle(location.pathname);

  return (
    <div className={`flex h-screen overflow-hidden bg-white`} dir={isRtl ? 'rtl' : 'ltr'}>
      <Sidebar 
        isMobileOpen={isMobileSidebarOpen}
        isDesktopCollapsed={isDesktopSidebarCollapsed}
        setIsDesktopCollapsed={setIsDesktopSidebarCollapsed}
        onCloseMobile={() => setIsMobileSidebarOpen(false)}
      />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header 
            toggleMobileSidebar={() => setIsMobileSidebarOpen(v => !v)}
            pageTitle={pageTitle}
        />
        <main className="flex-1 overflow-x-hidden overflow-y-auto p-4 md:p-6 relative z-10">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;